import Footer from "./Footer";
import Header from "./Header";
import { Outlet } from "react-router-dom"
import More from "./More";

const Layout = () => {
    return (
        <>
            <Header />
            <main className="page">
                <div className="layout">
                    <Outlet className="centerlayout" />
                    <More />
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Layout;